import { useLocation } from 'react-router-dom';
import { useOrganizationStore } from '../../stores/useOrganizationStore';
import { persistTrackingParams } from '../../utils/navigation';

/**
 * Component that ensures tracking parameters persist across route changes
 * Place this inside BrowserRouter to sync params on every navigation
 */
export const TrackingParamsSync = () => {
  const location = useLocation();
  const organization = useOrganizationStore((state) => state.organization);
  const currentUser = useOrganizationStore((state) => state.currentUser);

  // Re-apply tracking params whenever the route changes
  if (organization && currentUser) {
    persistTrackingParams({
      org_id: organization.id,
      org_name: organization.org_name,
      user_id: currentUser.uid,
      user_name: currentUser.displayName || '',
    });
  }

  return null;
};
